import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
// import { Link } from "react-router-dom";

const Team = () => {
  const team = [
    { id: 1, img: "/img/teams-1.jpg", name: "Muteeb Ahmad Khan", role: "Director" },
    { id: 2, img: "/img/team-2.jpg", name: "Arvind Verma", role: "General Manager" },
    { id: 3, img: "/img/team-3.jpg", name: "Name Goes Here", role: "Designation" },
    // { id: 4, img: "/img/team-4.jpg", name: "Name Goes Here", role: "Designation" },
    // { id: 5, img: "/img/team-1.jpg", name: "Name Goes Here", role: "Designation" },
  ];

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 1,
    },
  };

  return (
    <>
      <h2 className="text-center mb-2">Our Team</h2>
     <div className="container-fluid bg-light">
    <div className="container">
      <Carousel
        responsive={responsive}
        infinite={true}
        autoPlay={true}
        autoPlaySpeed={3000}
        arrows={true}
      >
        {team.map((t) => (
          <div key={t.id} className="px-3">

            <div className="text-center shadow">

              <img
                src={t.img}
                alt={t.name}
                className="img-fluid w-100"
                style={{ height: "400px", objectFit: "cover" }}
              />

              <div className="bg-dark text-white py-3">
                <h5 style={{ color: "white" }}>{t.name}</h5>
                <p className="m-0">{t.role}</p>
              </div>

              {/* <Link className="nav-item nav-link" to="#">More..</Link> */}

            </div>

          </div>
        ))}
      </Carousel>

    </div>
    </div>
    </>
  );
};

export default Team;